export default "__VITE_ASSET__jx1Op_iC__"